export default __webpack_public_path__ + "static/media/II-2017.99d6f06d.pdf";